import { useTranslation } from 'react-i18next';

const BankAccountCards = ({ accounts, selectable, selectedId, onSelect }) => {
  const { t } = useTranslation();
  if (!accounts?.length) return null;

  return (
    <div className="space-y-2">
      <p className="text-xs font-medium text-zinc-500">{t('payments.bank.transferTo')}</p>
      {accounts.map((account) => {
        const id = account._id;
        const selected = selectedId === id;
        const content = (
          <div className="text-sm">
            <p className="font-medium">{account.bankName}</p>
            <p className="text-zinc-600 dark:text-zinc-400">{account.accountName}</p>
            <p className="font-mono text-xs text-zinc-500">{account.accountNumber}</p>
            {account.branchName && (
              <p className="text-xs text-zinc-500">{account.branchName}</p>
            )}
          </div>
        );

        if (!selectable) {
          return (
            <div key={id} className="rounded-lg border border-zinc-200 dark:border-zinc-800 p-3">
              {content}
            </div>
          );
        }

        return (
          <label
            key={id}
            className={`block cursor-pointer rounded-lg border p-3 transition ${
              selected
                ? 'border-glow-500 bg-glow-600/10'
                : 'border-zinc-200 dark:border-zinc-800 hover:border-zinc-400 dark:hover:border-zinc-600'
            }`}
          >
            <input
              type="radio"
              name="bank-account"
              value={id}
              checked={selected}
              onChange={() => onSelect?.(id)}
              className="sr-only"
            />
            {content}
          </label>
        );
      })}
    </div>
  );
};

export default BankAccountCards;
